import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import deprecated from '../utils/deprecated';
import { FormCheck } from './FormCheck';
// eslint-disable-next-line
export const Checkbox = /*#__PURE__*/ React.forwardRef(({ validationState, children, ...rest }, ref)=>{
    deprecated('Checkbox', `The Checkbox component is deprecated and will be removed in a future release.
      Consider using the FormCheck component directly, with type={'checkbox'}`);
    const success = validationState === 'success';
    const warning = validationState === 'warning';
    const error = validationState === 'error';
    return /*#__PURE__*/ _jsx(FormCheck, {
        ...rest,
        ref: ref,
        type: 'checkbox',
        label: children,
        isSuccess: success,
        isWarning: warning,
        isError: error
    });
});
Checkbox.displayName = 'Checkbox';
